export * from 'af-actions/workOrder/workOrder.actions';
import type { WorkOrderAction as WorkOrderActionImport } from 'af-actions/workOrder/workOrder.actionCreators';

export type WorkOrderAction = WorkOrderActionImport;
